import { Box, Skeleton } from '@mui/material';
import { FC } from 'react';
import { ListItem } from '../../../../../layout/slideout/patient-profile-widget/patient-profile-widget.styles';
import { DotSeparatedSkeleton } from '../../../../../layout/slideout/patient-profile-widget/shared/skeleton/dot-separated-skeleton';
import { randomBetween } from '../../../../../layout/slideout/patient-profile-widget/utils/random-between';

export const VisitsSkeleton: FC = () => {
  const visits = Array.from({ length: 4 }, (_, i) => i);
  return (
    <>
      {visits.map(visit => (
        <ListItem key={`visit-skeleton-${visit}`} style={{ height: 78.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'start', flexDirection: 'row' }}>
            <Skeleton variant='circular' width={34} height={34} sx={{ marginRight: '12px' }} />
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <DotSeparatedSkeleton />
              <Box>
                <Skeleton variant='rounded' width={randomBetween(120, 190)} height={14} sx={{ marginTop: '4px' }} />
              </Box>
            </Box>
          </Box>
        </ListItem>
      ))}
    </>
  );
};
